import { Suspense } from 'react';
import LoadingT4Carrier from '@core/LoadingT4Carrier/index';

export const WrapperLoading = ({ children }: { children: React.ReactNode }) => {
  return <Suspense fallback={<LoadingT4Carrier />}>{children}</Suspense>;
};
